import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'The Sunday newsletter is the one email I actually look forward to. Every issue has at least one idea I implement that week.',
  author: 'Sarah K.',
  role: 'Product Manager'
}, {
  quote: 'I went from scattered to systematic in about a month of following the frameworks. The rolling time-block method changed everything.',
  author: 'Marcus T.',
  role: 'Founder'
}, {
  quote: 'Finally, productivity advice that respects your time. Short, actionable, no fluff.',
  author: 'Priya R.',
  role: 'Engineering Lead'
}];
export function SocialProof() {
  return <section className="py-20 bg-brand-cream border-t border-brand-navy/5" data-id="element-191">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-192">
        <div className="text-center mb-12" data-id="element-193">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-navy mb-4" data-id="element-194">
            What Readers Are Saying
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-195">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 flex flex-col" data-id="element-196">
              <div className="flex gap-1 text-brand-gold mb-4" data-id="element-197">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-198" />)}
              </div>
              <blockquote className="text-brand-slate flex-grow mb-6 italic leading-relaxed" data-id="element-199">
                "{testimonial.quote}"
              </blockquote>
              <div className="mt-auto" data-id="element-200">
                <div className="font-bold text-brand-navy" data-id="element-201">
                  {testimonial.author}
                </div>
                <div className="text-sm text-gray-500" data-id="element-202">{testimonial.role}</div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}